<template>
  <div id="my-support">
    <div class="row reverse-mobile" id="my-contracts">
      <div class="col-12 col-md-3">
        <UserMenu></UserMenu>
      </div>
      <div class="col-12 col-md-9">
        <div class="row mb-4">
          <div class="d-flex flex-row align-items-center">
            <i class="material-icons material-icons-title mr-2">new_releases</i>
            <h2 class="mt-2">View Pre-Releases</h2>
          </div>
        </div>
<!--        <div class="card">-->
<!--          <div class="card-body">-->
<!--            <div v-if="!isOnNative">-->
<!--              <div class="col-12 my-4 card bg-light">-->
<!--                <a-->
<!--                  href="itms-services://?action=download-manifest&url=https://api.isimulate.community/pre-release/download/1/RealitiBundle.plist"-->
<!--                >-->
<!--                  <div class="row pre-release card-body rounded bg-light py-3 d-flex">-->
<!--                    <div class="col-2 icon-container d-flex align-items-center">-->
<!--                      <i class="material-icons mr-1">get_app</i>-->
<!--                    </div>-->
<!--                    <div class="col-6 d-flex align-items-center">-->
<!--                      <div class>-->
<!--                        <h5>corpuls simulation Check</h5>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="col-4 d-flex align-items-center justify-content-end">-->
<!--                      <button-->
<!--                        class="btn btn-primary d-flex align-items-center justify-content-center my-4"-->
<!--                      >-->
<!--                        <i class="material-icons mr-1">cloud_download</i> Download-->
<!--                      </button>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </a>-->
<!--              </div>-->

<!--              &lt;!&ndash;<div class="col-12 my-4 card bg-light">&ndash;&gt;-->
<!--                &lt;!&ndash;<a&ndash;&gt;-->
<!--                  &lt;!&ndash;href="itms-services://?action=download-manifest&url=https://api.isimulate.community/api/pre-release/downloads/1"&ndash;&gt;-->
<!--                &lt;!&ndash;&gt;&ndash;&gt;-->
<!--                  &lt;!&ndash;<div class="row pre-release card-body rounded bg-light py-3 d-flex">&ndash;&gt;-->
<!--                    &lt;!&ndash;<div class="col-2 icon-container d-flex align-items-center">&ndash;&gt;-->
<!--                      &lt;!&ndash;<i class="material-icons mr-1">get_app</i>&ndash;&gt;-->
<!--                    &lt;!&ndash;</div>&ndash;&gt;-->
<!--                    &lt;!&ndash;<div class="col-6 d-flex align-items-center">&ndash;&gt;-->
<!--                      &lt;!&ndash;<div class>&ndash;&gt;-->
<!--                        &lt;!&ndash;<h5>corpuls simulation Check With Licensing</h5>&ndash;&gt;-->
<!--                      &lt;!&ndash;</div>&ndash;&gt;-->
<!--                    &lt;!&ndash;</div>&ndash;&gt;-->
<!--                    &lt;!&ndash;<div class="col-4 d-flex align-items-center justify-content-end">&ndash;&gt;-->
<!--                      &lt;!&ndash;<button&ndash;&gt;-->
<!--                        &lt;!&ndash;class="btn btn-primary d-flex align-items-center justify-content-center my-4"&ndash;&gt;-->
<!--                      &lt;!&ndash;&gt;&ndash;&gt;-->
<!--                        &lt;!&ndash;<i class="material-icons mr-1">cloud_download</i> Download&ndash;&gt;-->
<!--                      &lt;!&ndash;</button>&ndash;&gt;-->
<!--                    &lt;!&ndash;</div>&ndash;&gt;-->
<!--                  &lt;!&ndash;</div>&ndash;&gt;-->
<!--                &lt;!&ndash;</a>&ndash;&gt;-->
<!--              &lt;!&ndash;</div>&ndash;&gt;-->

<!--              <div class="col-12 my-4 card bg-light">-->
<!--                <a-->
<!--                  href="itms-services://?action=download-manifest&url=https://api.isimulate.community/pre-release/download/2/ALSi.plist"-->
<!--                >-->
<!--                  <div class="row pre-release card-body rounded bg-light py-3 d-flex">-->
<!--                    <div class="col-2 icon-container d-flex align-items-center">-->
<!--                      <i class="material-icons mr-1">get_app</i>-->
<!--                    </div>-->
<!--                    <div class="col-6 d-flex align-items-center">-->
<!--                      <div class>-->
<!--                        <h5>ALSi</h5>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="col-4 d-flex align-items-center justify-content-end">-->
<!--                      <button-->
<!--                        class="btn btn-primary d-flex align-items-center justify-content-center my-4"-->
<!--                      >-->
<!--                        <i class="material-icons mr-1">cloud_download</i> Download-->
<!--                      </button>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </a>-->
<!--              </div>-->

<!--              <div class="col-12 my-4 card bg-light">-->
<!--                <a-->
<!--                        href="itms-services://?action=download-manifest&url=https://api.isimulate.community/pre-release/download/3/CTGi.plist"-->
<!--                >-->
<!--                  <div class="row pre-release card-body rounded bg-light py-3 d-flex">-->
<!--                    <div class="col-2 icon-container d-flex align-items-center">-->
<!--                      <i class="material-icons mr-1">get_app</i>-->
<!--                    </div>-->
<!--                    <div class="col-6 d-flex align-items-center">-->
<!--                      <div class>-->
<!--                        <h5>CTGi</h5>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="col-4 d-flex align-items-center justify-content-end">-->
<!--                      <button-->
<!--                              class="btn btn-primary d-flex align-items-center justify-content-center my-4"-->
<!--                      >-->
<!--                        <i class="material-icons mr-1">cloud_download</i> Download-->
<!--                      </button>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </a>-->
<!--              </div>-->

<!--              <div class="col-12 my-4 card bg-light">-->
<!--                <a-->
<!--                        href="itms-services://?action=download-manifest&url=https://api.isimulate.community/pre-release/download/4/nano.plist"-->
<!--                >-->
<!--                  <div class="row pre-release card-body rounded bg-light py-3 d-flex">-->
<!--                    <div class="col-2 icon-container d-flex align-items-center">-->
<!--                      <i class="material-icons mr-1">get_app</i>-->
<!--                    </div>-->
<!--                    <div class="col-6 d-flex align-items-center">-->
<!--                      <div class>-->
<!--                        <h5>corpuls Nano</h5>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="col-4 d-flex align-items-center justify-content-end">-->
<!--                      <button-->
<!--                              class="btn btn-primary d-flex align-items-center justify-content-center my-4"-->
<!--                      >-->
<!--                        <i class="material-icons mr-1">cloud_download</i> Download-->
<!--                      </button>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </a>-->
<!--              </div>-->

<!--            </div>-->

<!--            <div v-else>-->
<!--              <div class="alert alert-secondary mt-4" role="alert">-->
<!--                <p class="mb-0 d-flex align-content-center">-->
<!--                  <i class="material-icons mr-2 text-black">warning</i>-->
<!--                  <strong></strong> To download corpuls pre-release software, please access Community via Safari.-->
<!--                </p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import UserMenu from "../components/UserMenu";
export default {
  name: "MyPreReleases",
  components: {
    UserMenu
  },
  computed: {
    isOnNative() {
      return this.$store.getters.getIsOnNative;
    }
  }
};
</script>


<style scoped >
.pre-release {
  color: #7d7d7d;
}

.pre-release .icon-container i {
  font-size: 50px;
  border: 5px solid #7d7d7d;
}

.material-icons-title {
  font-size: 50px;
  color: #7d7d7d;
}
</style>
